import { createSlice } from '@reduxjs/toolkit';
import { columnsStaticsData, columnsApplicationStaticsData, columnsEnvironmentStaticsData } from '../constants/RecommendationColumnData';
export const recommendationTable = createSlice({
  name: 'recommendationTable',
  initialState: {
    tableData: [],
    columnData: [],
    riskTableData: [],
    riskColumnData: [],
    showRecommendationTab: false,
    recommendationColumnData: columnsStaticsData,
    recommendationApplicationColumnData: columnsApplicationStaticsData,
    recommendationEnvironmentColumnData: columnsEnvironmentStaticsData
  },
  reducers: {
    pushTableData: (state, action) => {
      state.tableData = action.payload;
    },
    pushRiskTableData: (state, action) => {
      state.riskTableData = action.payload;
    },
    pushColumnData: (state, action) => {
      state.columnData = action.payload;
    },
    pushRiskColumnData: (state, action) => {
      state.riskColumnData = action.payload;
    },
    pushRecommendationUrl: (state, action) => {
      state.recommendationUrl = action.payload;
    },
    pushShowRecommendationTab: (state, action) => {
      state.showRecommendationTab = action.payload;
    },
    getApiResponse: (state, action) => {
      state[action.payload.type] = action.payload.data;
    },
    getRiskApiResponse: (state, action) => {
      state[action.payload.type] = action.payload.data;
    },
    getPostResponseAPI: (state, action) => {
      state[action.payload.type] = action.payload.data;
    },
    pushRecommendationColumnData: (state, action) => {
      state.recommendationColumnData = action.payload;
    },
    pushRecommendationApplicationColumnData: (state, action) => {
      state.recommendationApplicationColumnData = action.payload;
    },
    pushRecommendationEnvironmentColumnData: (state, action) => {
      state.recommendationEnvironmentColumnData = action.payload;
    }
  }
});
export const {
  pushTableData,
  pushColumnData,
  pushRecommendationUrl,
  getApiResponse,
  pushShowRecommendationTab,
  getRiskApiResponse,
  pushRiskTableData,
  pushRiskColumnData,
  getPostResponseAPI,
  pushRecommendationColumnData,
  pushRecommendationApplicationColumnData,
  pushRecommendationEnvironmentColumnData
} = recommendationTable.actions;
export default recommendationTable.reducer;